import { gql } from '@/features/graphql/generated'

export const ProductsQuery = gql(/* GraphQL */ `
    query Products {
        products {
            ...ProductItem
        }
    }
`)
